module.exports = __webpack_public_path__ + "static/media/Grupo 1138@2x.6efe1b26.png";